var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClippboard = function SvgClippboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "none",
    viewBox: "0 0 13 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.543.326C3.83.326 3.24.916 3.24 1.63a.49.49 0 10.978 0c0-.189.137-.326.326-.326h6.522c.19 0 .326.137.326.326v9.13c0 .19-.137.327-.326.327a.49.49 0 100 .978c.714 0 1.305-.59 1.305-1.304V1.63c0-.715-.59-1.305-1.305-1.305H4.543zM1.935 2.935c-.714 0-1.305.59-1.305 1.304v9.13c0 .715.59 1.305 1.305 1.305h6.521c.715 0 1.305-.59 1.305-1.304V4.24c0-.715-.59-1.305-1.305-1.305H1.935zm0 .978h6.521c.19 0 .327.137.327.326v9.13c0 .19-.137.327-.327.327H1.935a.315.315 0 01-.326-.326V4.24c0-.19.137-.327.326-.327z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
export default SvgClippboard;